<template>
  <popper trigger="click"
          placement="left"
          :arrow-size="14"
          :delay-on-mouse-over="500"
          :modifiers="popperModifiers"
          class="player-select-pop">
    <ul class="popper-content player-select">
      <li v-for="p in options" :key="p.pin" class="row player-option" @click="select(p)">
        <player-badge :player="p" class="cell"/>
      </li>
    </ul>
    <div class="row" slot="reference">
      <div class="cell selected-player">
        <span v-if="!currentPlayer">Player?</span>
        <player-badge v-if="currentPlayer" :player="currentPlayer" no-thumb/>
      </div>
    </div>
  </popper>
</template>

<script>
import Popper from './UI/Popper.js.vue'
import { mapState } from 'vuex'
import { Player } from '../../models/Player'
import PlayerBadge from './PlayerBadge'

export default {
  name: 'player-select',
  components: { Popper, PlayerBadge },

  props: {
    value: String,
    /** @type Player[] */
    options: Array,
    boundariesId: String
  },

  data () {
    return {
      selectedPlayer: null
    }
  },
  mounted () {
  },
  computed: {
    ...mapState(['accountPlayers']),

    allPlayers () {
      if (this.accountPlayers) {
        return this.accountPlayers.map(player => Player.fromJson(player))
      }
      return []
    },

    currentPlayer () {
      if (this.value) {
        const player = this.allPlayers.find(p => p.key === this.value)
        return player || null
      }
      return null
    },

    popperModifiers () {
      const boundaries = document.getElementById('popup-player-controller')
      return [
        {
          name: 'preventOverflow',
          options: {
            padding: 32,
            boundariesElement: boundaries
          }
        },
        {
          name: 'setHeight',
          enabled: true,
          phase: 'write',
          options: {
            padding: 32,
            boundariesElement: boundaries
          },
          fn ({ state, options }) {
            const boundH = options.boundariesElement.getBoundingClientRect().height - options.padding * 2
            if (boundH <= state.rects.popper.height) {
              state.elements.popper.style.height = boundH + 'px'
            }
          }
        }
      ]
    }
  },

  methods: {
    select (player) {
      this.selectedPlayer = player
      this.$emit('input', player.key)
    }
  }
}
</script>

<style lang="scss">
  @import "../../scss/vars";

  .player-select-pop {
    .player-select {
      .player-badge {
        padding: 0 $basic-size / 2;
      }
    }
    .selected-player, .player-option{
      cursor: pointer;
    }
    .popper {
      --popper-border-width: 2px;
      padding: 0;
    }
  }

</style>
